<template>
  <v-card class="assets-table">
    <v-card-title class="toolbar white--text">
      <h2>Assets ({{ filteredItems.length }} of {{ pagination.totalItems }})</h2>
      <v-spacer />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search assets by wpnr, title, issuer..."
        single-line
        hide-details
      />
    </v-card-title>

    <v-card-title class="filters grey lighten-5">
      <div class="filters__header">
        Filtered results ({{ filteredResults.length }} of {{ filteredItems.length }})
        <v-tooltip
          v-if="!hasResultFilters"
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              color="secondary"
              v-on="on"
            >
              <v-icon>
                filter_list
              </v-icon>
            </v-btn>
          </template>
          <span>Filters</span>
        </v-tooltip>
        <v-tooltip
          v-else
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              color="primary"
              v-on="on"
              @click="resetResultsFilters"
            >
              <v-icon>
                restore
              </v-icon>
            </v-btn>
          </template>
          <span>Reset filters</span>
        </v-tooltip>
      </div>
      <v-text-field
        v-model="resultFilters.searchResults"

        class="ml-5"
        append-icon="search"
        label="filter results"
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredResults"
      :total-items.sync="assetsPagination.total"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      item-key="id"
      class="elevation-1"
      :pagination.sync="pagination"
      @update:pagination="updatePagination"
    >
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          @click="props.expanded = !props.expanded"
        >
          <td>
            {{ props.item.id }}
          </td>
          <td>
            {{ props.item.title }}
          </td>
          <td>
            {{ props.item.wpnr }}
          </td>
          <td>
            {{ props.item.issuer }}
          </td>
          <td>
            {{ props.item.blocked && props.item.blocked_historic ? 'HISTORICAL BLOCKED' : '' }}
            {{ props.item.blocked && !props.item.blocked_historic ? 'BLOCKED' : '' }}
          </td>
          <td>
            <v-tooltip
              v-if="!props.item.blocked && !props.item.blocked_historic"
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="red"
                  flat
                  icon
                  v-on="on"
                  @click.stop="openBlockAssetModal(props.item)"
                >
                  <v-icon>block</v-icon>
                </v-btn>
              </template>
              <span>block payout</span>
            </v-tooltip>
            <v-tooltip
              v-if="props.item.blocked || props.item.blocked_historic"
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="green"
                  flat
                  icon
                  v-on="on"
                  @click.stop="removeBlockFromAsset(props.item)"
                >
                  <v-icon>play_arrow</v-icon>
                </v-btn>
              </template>
              <span>remove block</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <block-asset
      :dialog="blockAssetModal"
      :asset="selectedAsset"
      :submit-action="submitBlockAsset"
      :cancel-action="closeBlockAssetModal"
    />
  </v-card>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { formatDate, formatDateSmall } from '../../utils/dateFormats';
import { toQueryString, setQuery } from '@/helpers';
import BlockAsset from './BlockAsset';

export default {
  name: 'AssetsTable',
  components: {
    'block-asset': BlockAsset,
  },
  props: {
    assets: {
      type: Array,
      default: () => [],
    },
    assetsPagination: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadTableData: false,
      selectedAsset: null,
      search: undefined,
      selected: [],
      blockAssetModal: false,
      pagination: {
        page: this.assetsPagination.page,
        rowsPerPage: this.assetsPagination.limit,
        sortBy: 'created_at',
        descending: true,
      },
      rowsPerPageItems: [
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      filters: {
        createdAt: [],
        state: [],
      },
      resultFilters: {
        searchResults: null,
      },
      headers: [
        {
          text: 'Id',
          align: 'left',
          value: 'id',
        },
        {
          text: 'Title',
          align: 'left',
          value: 'title',
        },
        {
          text: 'Wpnr',
          align: 'left',
          value: 'wpnr',
        },
        {
          text: 'Issuer',
          align: 'left',
          value: 'issuer',
        },
        {
          text: 'Block',
          align: 'left',
          value: 'blocked',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      formatDateSmall,
      formatDate,
    };
  },
  computed: {
    filteredItems() {
      return this.assets.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
    filteredResults() {
      if (this.hasResultFilters) {
        return this.filteredItems.filter((item) => {
          let hasSearch = false;
          const { searchResults } = this.resultFilters;
          if (searchResults) {
            hasSearch = JSON.stringify(item)
              .toLowerCase()
              .includes(searchResults.toLowerCase());
          }

          return (!!hasSearch) || false;
        });
      }

      return this.filteredItems;
    },
    hasResultFilters() {
      return !!this.resultFilters.searchResults;
    },
  },
  watch: {
    async assets() {
      this.getDefaultFilters();
      await this.$nextTick();
      await this.changePage();
    },
    assetsPagination: {
      immediate: false,
      async handler(assetsPagination) {
        if (assetsPagination) {
          this.pagination.page = assetsPagination.page;
          this.pagination.rowsPerPage = assetsPagination.limit;
          this.pagination.totalItems = assetsPagination.total;
        }
      },
    },
    search: {
      immediate: false,
      handler(search, oldSearch) {
        if (search !== oldSearch) {
          setQuery(
            {
              search,
            },
            this.$route,
            this.$router,
          );
          this.refreshTable();
        }
      },
    },
    pagination: {
      immediate: false,
      handler(pagination, oldPagination) {
        if (!_.isEqual({
          descending: pagination.descending,
          page: pagination.page,
          rowsPerPage: pagination.rowsPerPage,
          sortBy: pagination.sortBy,
          totalItems: pagination.totalItems,
        }, {
          descending: oldPagination.descending,
          page: oldPagination.page,
          rowsPerPage: oldPagination.rowsPerPage,
          sortBy: oldPagination.sortBy,
          totalItems: oldPagination.totalItems || 0,
        })) {
          if (pagination.sortBy) {
            this.refreshTable();
          }
        }
      },
    },
  },
  methods: {
    ...mapActions([
      'getAssets',
      'blockAsset',
      'removeBlock',
    ]),
    refreshTable() {
      const query = toQueryString({
        page: this.pagination.page || 1,
        limit: this.pagination.rowsPerPage || 25,
        search: this.search,
        sort: this.pagination.sortBy,
        dir: this.pagination.descending ? 'desc' : 'asc',
      });
      if (typeof window.LIT !== 'undefined') {
        clearTimeout(window.LIT);
      }
      window.LIT = setTimeout(() => {
        this.getAssets(query);
      }, 1000);
    },
    updatePagination(pagination) {
      setQuery(
        {
          page: pagination.page,
          sortBy: pagination.sortBy,
          dir: pagination.descending ? 'desc' : 'asc',
          search: this.search,
        },
        this.$route,
        this.$router,
      );
    },
    async changePage() {
      const { page, search } = this.$route.query;
      this.search = search;
      await this.$nextTick();
      this.isLoadTableData = true;
      this.pagination.page = page ? Number(page) : 1;
    },
    getDefaultFilters() {
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach((item) => {
          let value = this.$route.query[item];

          if (Object.prototype.hasOwnProperty.call(this.filters, item)) {
            if (typeof this.filters[item] === 'string') {
              this.filters[item] = value;
            } else if (String(this.$route.query[item]).includes(';')) {
              value = this.$route.query[item].split(';');
              this.filters[item] = value;
            } else {
              this.filters[item].push(value);
            }
          }
        });
      }
    },
    resetResultsFilters() {
      this.resultFilters = _.mapValues(this.resultFilters, () => null);
    },
    async submitBlockAsset(data) {
      await this.blockAsset(data)
        .then(this.refreshTable);
      this.selectedAsset = null;
      this.blockAssetModal = false;
    },
    openBlockAssetModal(asset) {
      this.selectedAsset = asset;
      this.blockAssetModal = true;
    },
    closeBlockAssetModal() {
      this.selectedAsset = null;
      this.blockAssetModal = false;
    },
    removeBlockFromAsset(asset) {
      this.removeBlock(asset.wpnr)
        .then(this.refreshTable);
    },
  },
};
</script>

<style lang="scss" scoped>
.assets-table{
  a {
    text-decoration: none;
    color: black;
  }

  .toolbar {
    background-color: #1a4c7d;
    color: white;
  }

  .infoLabel {
    margin-left: 16px;
  }

  .countLabel {
    color: #fff;
  }
  .expanded-details {
    background-color: #eaeaea;
    padding: 20px;
  }

  .v-select{
        flex: 1;
  }

  table.v-table {
    td:not(:first-child),
    th:not(:first-child) {
      padding: 0 1% !important;
    }
  }

  .v-card__title.subheading{
    .v-icon{
      margin-right:10px;
    }
  }
  .v-input{
    &.security_wallet{
      min-width: 350px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/baader/AssetsTable.vue